import App from './App'
import { createSSRApp } from 'vue'
import * as Pinia from 'pinia'
import '@/el-ui/index.js'
import config from '@/config/index.js'

uni.$config.set(config);

export function createApp() {
  const app = createSSRApp(App)
  app.use(Pinia.createPinia())
  return {
    app,
	Pinia
  }
}